import { useCallback, useEffect, useRef, useState } from 'react';
import { GAME } from '../config.js';
import { resolveBurstTone } from './PopBurst.jsx';

const BURST_DURATION_MS = 580;
const MAX_BURSTS = GAME.MAX_BURST_EFFECTS;

/**
 * Queues short-lived pop bursts at item positions when the player taps a card.
 */
export function usePopBursts() {
    const [bursts, setBursts] = useState([]);
    const timersRef = useRef(new Set());

    const clearTimer = useCallback((timerId) => {
        window.clearTimeout(timerId);
        timersRef.current.delete(timerId);
    }, []);

    useEffect(() => {
        const timers = timersRef.current;
        return () => {
            timers.forEach((id) => window.clearTimeout(id));
            timers.clear();
        };
    }, []);

    const spawnBurst = useCallback(
        (item) => {
            const burstId = `burst-${item.id}-${Date.now()}`;
            const tone = resolveBurstTone(item);

            setBursts((current) => {
                const next = [...current, { id: burstId, item, tone }];
                return next.length > MAX_BURSTS ? next.slice(-MAX_BURSTS) : next;
            });

            const timerId = window.setTimeout(() => {
                setBursts((current) => current.filter((burst) => burst.id !== burstId));
                clearTimer(timerId);
            }, BURST_DURATION_MS);

            timersRef.current.add(timerId);
        },
        [clearTimer],
    );

    return { bursts, spawnBurst };
}
